import { render, staticRenderFns } from "./Withdraw_sel.vue?vue&type=template&id=f0d418d4&scoped=true"
import script from "./Withdraw_sel.vue?vue&type=script&lang=js"
export * from "./Withdraw_sel.vue?vue&type=script&lang=js"
import style0 from "./Withdraw_sel.vue?vue&type=style&index=0&id=f0d418d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d418d4",
  null
  
)

/* custom blocks */
import block0 from "./Withdraw_sel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports